import CategoriesData from "../CategoriesData/CategoriesData";

export default function Acting() {
  return (
    <>
      <div className="p-4">
        <h1>Acting</h1>
        <hr />
        <CategoriesData catType="Acting" />
      </div>
    </>
  );
}
